import {Component, Input} from '@angular/core';
import {UserResponse} from '../../../../@shared/models/response.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditUserProfile} from './components/edit-user-profile/edit-user-profile';
import {formatTimeYMD} from '../../../../@core/utils/utils.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-profile-overview',
  standalone: false,
  templateUrl: './user-profile-overview.html',
  styleUrl: './user-profile-overview.css'
})
export class UserProfileOverview {
  @Input() user: UserResponse

  constructor(private modal: NgbModal,
              private router: Router) {
  }

  openEditProfileModal() {
    let modalRef = this.modal.open(EditUserProfile, {size: 'lg', centered: true});
    modalRef.componentInstance.user = this.user;
    modalRef.result.then((result) => {
      if (result) {
        this.user = result;
        // Delay reload to allow toast to be visible
        setTimeout(() => location.reload(), 1500);
      }
    })
  }

  formatAddress(user: UserResponse): string {
    const parts: string[] = [];

    if (user.address) {
      parts.push(user.address);
    }

    // Combine zip_code and city
    const cityPart = [user.zip_code, user.city].filter(Boolean).join(' ');
    if (cityPart) {
      parts.push(cityPart);
    }

    if (user.country) {
      parts.push(user.country);
    }

    return parts.join(', ');
  }

  protected readonly formatTimeYMD = formatTimeYMD;
  protected readonly Date = Date;
}
